export function getPreLeadReason(prelead) {
  if (!prelead) return '';
  return String(prelead.reason ?? '').trim();
}

export function isPreleadSettled(prelead) {
  return prelead?.lead_id != null || prelead?.is_disqualified === true;
}

export function hasPreleadNoteToView(prelead) {
  if (isPreleadSettled(prelead)) {
    return Boolean(getPreLeadReason(prelead) || getPreLeadLog(prelead));
  }
  return Boolean(getPreLeadLog(prelead));
}

export function getPreLeadLog(prelead) {
  if (!prelead) return '';
  if (typeof prelead === 'string') return prelead.trim();
  const direct = prelead.log ?? prelead.telecalling_log ?? null;
  if (typeof direct === 'string') return direct.trim();
  const logs = getPreLeadLogs(prelead);
  return logs.length > 0 ? getPreLeadLogText(logs[0]) : '';
}

export function getPreLeadLogs(preleadOrLogs) {
  if (!preleadOrLogs) return [];
  if (Array.isArray(preleadOrLogs)) return preleadOrLogs;

  const direct = preleadOrLogs.log ?? preleadOrLogs.telecalling_log;
  if (typeof direct === 'string' && direct.trim()) {
    return [
      {
        log: direct.trim(),
        updated_at: preleadOrLogs.updated_at ?? preleadOrLogs.updatedAt ?? null
      }
    ];
  }

  const raw =
    preleadOrLogs.logs ??
    preleadOrLogs.pre_lead_logs ??
    preleadOrLogs.PreLeadLogs ??
    preleadOrLogs.preLeadLogs ??
    [];
  return Array.isArray(raw) ? raw : [];
}

export function getPreLeadLogText(entry) {
  return String(entry?.log ?? entry?.message ?? entry?.description ?? entry?.text ?? '').trim();
}

export function getPreLeadLogAuthor(entry) {
  const user =
    entry?.user ??
    entry?.User ??
    entry?.added_by ??
    entry?.addedBy ??
    entry?.created_by ??
    entry?.createdBy ??
    null;
  if (!user) return '—';
  if (typeof user === 'string') return user;
  return user.name ?? user.full_name ?? user.email ?? '—';
}

export function getPreLeadLogDate(entry) {
  return entry?.created_at ?? entry?.createdAt ?? entry?.updated_at ?? entry?.updatedAt ?? null;
}

export function sortPreLeadLogsNewestFirst(logs) {
  return [...getPreLeadLogs(logs)].sort((a, b) => {
    const ta = new Date(getPreLeadLogDate(a) ?? 0).getTime();
    const tb = new Date(getPreLeadLogDate(b) ?? 0).getTime();
    return tb - ta;
  });
}
